export default __webpack_public_path__ + "static/media/up-arrow.34c44821.svg";